/**
 * Validation of a blocked-MIME pattern (D31 decision 13): `type/subtype` or
 * `type/*`, case-insensitive, matched by the server against the DETECTED type
 * of an upload. The server validates too — this only lets the form refuse an
 * obvious typo before a round trip, and it must accept nothing the server would
 * reject, or the error the user sees comes from the wrong place.
 */

// RFC 2045 token characters, minus the ones that are never in a real media type
// (no quotes, no spaces, no slashes). Both halves start with an alphanumeric.
const TOKEN = "[a-z0-9][a-z0-9!#$&^_.+-]{0,126}"
const PATTERN = new RegExp(`^${TOKEN}/(\\*|${TOKEN})$`, 'i')

/** True for `image/png`, `application/x-msdownload`, `image/*`; false for `notatype`, a bare star-slash-star, `image/`. */
export function isMimePattern(value: string): boolean {
  return PATTERN.test(value.trim())
}

/** The canonical form the server stores: trimmed and lower-cased. */
export function normaliseMimePattern(value: string): string {
  return value.trim().toLowerCase()
}
